import React from "react";
import { Alert} from "react-bootstrap";
const ToolDesc = () => {
  return (
    <div className="print_disnone">
      <h1 className="mto15">New Model Decoder</h1>
      <p>
        Heatcraft is implementing a new model nomenclature format to simplify
        and streamline the ordering process.To ensure a smooth transition, we
        have created a series of tools to help customers navigate through the
        move from legacy model numbers to new model numbers.
      </p>
      
                
                
    </div>
    
  );
};
export default ToolDesc;
